/*------------------------------------*\
    HEADER
\*------------------------------------*/
class CategoryNav {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
    }

    init() {
        let self = this;

        self.navToggle();
    }

    navToggle() {
        let self = this;

        const toggle = document.querySelector('[data-category-nav-toggle]');
        const nav = document.querySelector('[data-category-nav]');

        toggle.addEventListener('click', evt => {
            evt.preventDefault();
            nav.classList.toggle('show');
            toggle.classList.toggle('collapsed');
        });
    }
}

export default CategoryNav;